import { Dispatch } from 'redux';

import { calendarActions } from '@state/calendar';
import { taskActions } from '@state/task';

export const refreshAfterAssistantAction = (
  dispatch: Dispatch,
  actionType: string,
  result: Record<string, unknown> | unknown[] | null | undefined
) => {
  dispatch(calendarActions.calendarData.request());

  switch (actionType) {
    case 'create_task':
      if (Array.isArray(result)) {
        dispatch(taskActions.createTasks.success({ tasks: result as any }));
      }
      break;
    case 'complete_task':
      if (result && typeof result === 'object' && !Array.isArray(result)) {
        const taskId = (result as Record<string, unknown>).taskId;
        if (typeof taskId === 'number') {
          dispatch(taskActions.updateTaskStatus.success({ ...(result as object), taskId } as any));
        }
      }
      dispatch(calendarActions.getPlannedTasks.request());
      break;
    case 'plan_study_block':
      dispatch(calendarActions.getPlannedTasks.request());
      break;
    default:
      break;
  }
};
